import { usePlaidLink } from 'react-plaid-link';
import { useCallback, useEffect } from 'react';

/**
 * PlaidPayment
 *
 * @return {JSX.Element}
 */
const PlaidPayment = ({ className, token, onResult }) => {
  const handleResult = useCallback(
    (publicToken, metadata) => {
      onResult(null, { publicToken, metadata });
    },
    [onResult]
  );
  const handleExitError = useCallback((data) => onResult(data), [onResult]);

  const { open, ready, error } = usePlaidLink({
    // env: 'sandbox',
    token,
    onSuccess: handleResult,
    onExit: handleExitError,
  });
  console.log('render PlaidLinkWithToken');

  useEffect(() => {
    if (ready) {
      console.log('CALLING OPEN');
      open();
    }
  }, [ready, open]);

  useEffect(() => {
    if (error) {
      handleExitError(error);
    }
  }, [handleExitError, error]);

  return null;
};

PlaidPayment.displayName = 'PlaidPayment';

export default PlaidPayment;
